/* DasiFrères — Cohérence Mouture ⇄ Conditionnement pour les produits mixtes
 * (café vendu en formats moulables 250G/1KG ET en capsules/vrac).
 *
 * Problème : les variantes capsule/vrac n'ont pas de mouture réelle ; l'import
 * leur attribue le placeholder « Standard » (Shopify impose une valeur par
 * option). Quand on sélectionne une capsule, le picker garde la mouture
 * précédente (ex. GRAINS) → combinaison inexistante → « Non disponible ».
 * Shopify n'auto-corrige pas la combinaison invalide.
 *
 * Ce script écoute en phase de CAPTURE (donc AVANT le handler du <variant-picker>,
 * cf. assets/variant-picker.js → get selectedOptionsValues) et :
 *   - capsule/vrac sélectionné  → coche « Standard » (variante valide se résout),
 *   - format moulable sélectionné alors que « Standard » était actif → coche la
 *     1re vraie mouture (ex. GRAINS).
 * Le bloc Mouture lui-même est masqué visuellement par assets/gamme-fonds.css.
 */
(function () {
  if (window.__dasiCapsuleMouture) return;
  window.__dasiCapsuleMouture = true;

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

      var picker = input.closest('variant-picker');
      if (!picker) return;

      // Le fieldset Mouture est celui qui contient le placeholder « Standard ».
      var fieldsets = picker.querySelectorAll('fieldset');
      var moutureField = null;
      for (var i = 0; i < fieldsets.length; i++) {
        if (fieldsets[i].querySelector('input[type="radio"][value="Standard" i]')) {
          moutureField = fieldsets[i];
          break;
        }
      }
      if (!moutureField) return; // produit sans placeholder → rien à faire
      if (moutureField.contains(input)) return; // changement d'une mouture → on n'y touche pas

      var standard = moutureField.querySelector('input[type="radio"][value="Standard" i]');
      if (!standard) return;

      var isNonGrindable = /capsule|vrac/i.test(input.value || '');

      if (isNonGrindable) {
        if (!standard.checked) selectMouture(picker, standard);
      } else {
        // Format moulable sélectionné.
        if (standard.checked) {
          // « Standard » était actif → coche la 1re vraie mouture (ex. GRAINS).
          // On supprime les transitions du fieldset le temps du basculement : sinon
          // la pastille brune « glisse » depuis la position de « Standard » (masqué)
          // jusqu'à GRAINS sur 0,25 s → on voit un fond blanc qui se remplit, ça fait
          // bug. Les sélections manuelles ultérieures gardent leur animation normale.
          suppressAnim(moutureField);
          var radios = moutureField.querySelectorAll('input[type="radio"]');
          for (var j = 0; j < radios.length; j++) {
            if (radios[j] !== standard) {
              selectMouture(picker, radios[j]);
              break;
            }
          }
        }
        // Nettoyage OPTIMISTE de l'indisponibilité périmée des moutures.
        //
        // Quand une capsule/vrac était sélectionnée, le picker a été rendu côté
        // serveur pour « …/Standard » : dans ce rendu les vraies moutures (GRAINS…)
        // sont marquées indisponibles (rayées) car la combinaison n'existe pas.
        // Le bloc Mouture était masqué (CSS), mais en repassant sur un format
        // moulable il redevient visible AVANT que le fetch Section Rendering
        // (~qq s) ne renvoie l'état correct → on voyait GRAINS rayé puis re-dispo.
        //
        // On retire donc tout de suite ces marqueurs périmés. Le fetch qui suit
        // restaure l'état exact (et re-raye une mouture réellement indispo, cas rare).
        clearStaleMoutureUnavailability(moutureField, standard);
      }
    },
    true,
  );

  // Coche une mouture EN PASSANT par la logique interne du <variant-picker>
  // (updateSelectedOption) plutôt que radio.checked = true directement.
  //
  // Pourquoi : le picker mémorise l'index coché de chaque fieldset (#checkedIndices)
  // et s'en sert pour mesurer la largeur de la pastille (pill) au re-render. Si on
  // coche la mouture en contournant le picker, cet index reste pointé sur l'ancienne
  // valeur (« Standard », masqué → largeur 0), et au morph la pastille brune du
  // bouton sélectionné se réduit à 0 → bouton « blanc » qui clignote. En passant par
  // updateSelectedOption, l'état du picker reste cohérent et la pastille est correcte.
  function selectMouture(picker, radio) {
    try {
      if (picker && typeof picker.updateSelectedOption === 'function') {
        picker.updateSelectedOption(radio);
        return;
      }
    } catch (err) {
      /* repli ci-dessous si la méthode change/échoue */
    }
    radio.checked = true;
  }

  // Supprime transitions/animations du fieldset pendant 2 frames, le temps que
  // l'état sélectionné (pastille brune sur GRAINS) se peigne d'un coup, sans glisser.
  function suppressAnim(fieldset) {
    if (!fieldset || !fieldset.classList) return;
    fieldset.classList.add('dasi-suppress-anim');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fieldset.classList.remove('dasi-suppress-anim');
      });
    });
  }

  function clearStaleMoutureUnavailability(moutureField, standard) {
    var labels = moutureField.querySelectorAll('.variant-option__button-label');
    for (var i = 0; i < labels.length; i++) {
      var radio = labels[i].querySelector('input[type="radio"]');
      if (!radio || radio === standard) continue; // on ne touche pas au placeholder
      radio.setAttribute('data-option-available', 'true');
      radio.removeAttribute('aria-disabled');
      var strike = labels[i].querySelector('.variant-option__strikethrough');
      if (strike) strike.remove();
    }
  }
})();
